import { server } from '@/helpers';

/**
 * Mirrors the backend `BokadirektPaymentObject` io-ts union in
 * `backend/main/routes/mobileapi/checkout/data.ts`.
 */
export type BundleCheckoutPaymentMethod =
  | { type: 'Klarna' }
  | { type: 'Card'; cardId: string }
  | { type: 'GooglePay' }
  | { type: 'ApplePay' }
  | { type: 'Swish' }
  | { type: 'Walley'; phoneNumber: string };

export interface BundleCheckoutRequest {
  bundleTemplateId: number;
  placeId: number;
  paymentMethod: BundleCheckoutPaymentMethod;
  redirectInfo: {
    returnUrl: string;
    channel: 'Web' | 'iOS' | 'Android';
    browserInfo?: {
      acceptHeader?: string;
      colorDepth?: number;
      javaEnabled?: boolean;
      language?: string;
      screenHeight?: number;
      screenWidth?: number;
      timeZoneOffset?: number;
      userAgent?: string;
    };
  };
  formValues?: { '1': { nationalId: string } };
}

export interface BundleCheckoutSessionResponse {
  sessionId: string;
  sessionData: string;
  paymentId: number;
  bundleTemplateId: number;
  checkoutRef: string;
}

export interface BundleCheckoutResultCodeResponse {
  resultCode: string;
  refusalReason: string | null;
  refusalReasonCode: string | null;
  bundleTemplateId: number;
  checkoutRef: string;
}

export type BundleCheckoutResponse = BundleCheckoutSessionResponse | BundleCheckoutResultCodeResponse;

/**
 * Initiate a bdpay bundle purchase.
 */
function checkout(data: BundleCheckoutRequest): Promise<BundleCheckoutResponse> {
  return server.request.post('/bundle/checkout', data).then(server.handleSuccess).catch(server.handleErrorObject);
}

export const bundlesServices = {
  checkout,
};
